import {ProcessEntity} from "../../domain/entity/process.entity";
import {AttendanceEntity} from "../../domain/entity/attendance.entity";
import {useProcessRepository} from "../../../../../../domain/repository/process.repository";
import React, {useCallback} from "react";
import {ProcessFormComponent} from "../process.form.component";

export function AttendanceProcessComponent(props: {
  process?: ProcessEntity,
  attendance: AttendanceEntity,
  reload: CallableFunction,
}) {
  const processRepo = useProcessRepository();
  
  const onSubmit = useCallback((values: any) => {
    if (props.process) {
      return processRepo
        .edit(props.process.id, values)
        .then(res => props.reload())
    } else {
      values.attendanceId = props.attendance.id
      return processRepo.create(values)
        .then(res => props.reload())
    }
  }, []);
  
  
  return (
    <ProcessFormComponent
      onSubmit={onSubmit}
      initialValue={props.process}
    />
  )
}